/* Step One — Women's landing page: scroll reveal + smooth anchor scroll.
   Idempotent: safe to include from every s1-wl-* section. */
(function () {
  if (window.__s1wl) return;
  window.__s1wl = true;

  var root = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var targets = document.querySelectorAll('.s1-wl-fade, .s1-wl-stagger');
    if (!targets.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    root.classList.add('s1-wl-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el) { io.observe(el); });
    // Safety net: if the observer never fires (hidden tab, editor iframe, odd
    // scroll containers) reveal everything after a short delay.
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
    }, 3000);
  }

  function anchors() {
    document.querySelectorAll('.s1-wl a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', id);
      });
    });
  }

  // Count-up for stats ("79%", "65,000+", "57,000+"): animates the leading number, keeps prefix/suffix.
  function countUp(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var text = el.textContent.trim();
    var m = text.match(/^([^\d]*)(\d[\d,\.]*)(.*)$/);
    if (!m) return;
    var target = parseFloat(m[2].replace(/,/g, ''));
    if (isNaN(target)) return;
    var decimals = (m[2].split('.')[1] || '').length;
    var useCommas = m[2].indexOf(',') !== -1;
    var start = null, dur = 1400;
    function fmt(n) {
      var f = n.toFixed(decimals);
      return useCommas ? Number(f).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : f;
    }
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = m[1] + fmt(target * eased) + m[3];
      if (p < 1) requestAnimationFrame(step); else el.textContent = text;
    }
    requestAnimationFrame(step);
  }

  function counters() {
    var els = document.querySelectorAll('.s1-wl-fabric__stat strong, .s1-wl-trust__tile strong');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { countUp(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { reveal(); anchors(); counters(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-arm reveals when a section is (re)loaded.
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.s1-wl-fade, .s1-wl-stagger').forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
